module.exports = __webpack_public_path__ + "static/img/tisheng.0ab2560.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/tisheng.jpg
// module id = A/OF
// module chunks = 1